/** @jsx jsx */
import { MultiButton, Spacer, TextGroupMedium } from "@cd2/components/build/es6"
import { IComponentProp } from "@cd2/components/build/es6/types/utils"
import { P } from "@cd2/text/build/es6"
import { css, jsx } from "@emotion/core"

import React from "react"
import { IPageProps } from "../types/common"
import { LinkButton } from "./Buttons/LinkButton"

export function NotFoundPage({
  actions,
  extraMessage
}: {
  actions?: IComponentProp<typeof MultiButton, "buttons">
  extraMessage?: React.ReactNode
} & Partial<IPageProps<any>>) {
  return (
    <div
      css={css`
        padding: 10% 32px;
      `}
    >
      <TextGroupMedium
        heading="Not found"
        body={
          <React.Fragment>
            {extraMessage && <p>{extraMessage}</p>}
            <P weight={600}>If you believe this is an error - please contact support</P>
            <Spacer size={24} />
            {actions ? (
              <MultiButton buttons={actions} />
            ) : (
              <LinkButton to="/" buttonColor="white">
                Back to the dashboard
              </LinkButton>
            )}
          </React.Fragment>
        }
      />
    </div>
  )
}
